module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/th/2-958ddc0bb0f97a7add3e2551b6093357.jpg";